import { create } from 'zustand'
import { devtools } from 'zustand/middleware'

interface SidebarState {
  isSidebarCollapsed: boolean
  setSidebarCollapsed: (collapsed: boolean) => void
}

export const useSidebarStore = create<SidebarState>()(
  devtools(
    (set) => ({
      isSidebarCollapsed: false,
      setSidebarCollapsed: (collapsed: boolean) => {
        set({ isSidebarCollapsed: collapsed }, false, 'setSidebarCollapsed')
      },
    }),
    { name: 'SidebarStore' }
  )
)
